module.exports = __webpack_public_path__ + "fonts/DroidSans.e1a08b5.woff2";